var app = angular.module('app');
app.controller('appCtrl', ["$scope", "$firebaseAuth", "$firebaseArray", "$q", function ($scope, $firebaseAuth, $firebaseArray, $q) {
    $scope.title = 'Kill Submission';
    $scope.authObj = $firebaseAuth();

    $scope.authObj.$requireSignIn().then(function(firebaseUser) {
        return firebaseUser.getIdTokenResult();
    }).then(function(idTokenResult) {
        var role = idTokenResult.claims.role;
        var isAdmin = idTokenResult.claims.admin;
        if (!isAdmin && role !== 'kill-submitter') {
            window.location.href = '/';
        }
    }).catch(function(error) {
        window.location.href = '/login/login';
    });

    var ref = firebase.database().ref();
    $scope.remoteItems = $firebaseArray(ref.child("submission"));
    $scope.guilds = $firebaseArray(ref.child("guild"));
    $scope.expansions = $firebaseArray(ref.child("expansion"));
    $scope.zones = $firebaseArray(ref.child("zone"));
    $scope.bosses = $firebaseArray(ref.child("boss"));

    var defaultTime = new Date();
    defaultTime.setSeconds(0, 0);

    $scope.value = {
        guild: '',
        expansion: '',
        zone: '',
        boss: '',
        timestamp: defaultTime,
        imageUrl: ''
    };

    $scope.isUploading = false;

    setTimeout(function() {
        var fileupload = document.getElementById("fileupload");
        if(fileupload) {
            fileupload.addEventListener('change', function (e) {
                var file = e.target.files[0];
                if (!file) return;

                $scope.$apply(function() {
                    $scope.isUploading = true;
                });

                var storageRef = firebase.storage().ref('submission/' + file.name);
                var metadata = {
                    cacheControl: 'public,max-age=2592000', // Cache for 30 days
                };
                storageRef.put(file, metadata).then(function (snapshot) {
                    snapshot.ref.getDownloadURL().then(function (url) {
                        $scope.$apply(function () {
                            $scope.value.imageUrl = url;
                            $scope.isUploading = false;
                        });
                    });
                }).catch(function(error) {
                    $scope.$apply(function() {
                        $scope.isUploading = false;
                        console.error("Error uploading image:", error);
                        alert("Error uploading image: " + error.message);
                    });
                });
            });
        }
    }, 500);

    $scope.add = function (value) {
        if ($scope.isUploading) {
            alert('Please wait for the image to finish uploading before submitting.');
            return;
        }

        var data = angular.copy($scope.value);
        
        // Safely convert timestamp whether it's a Date object or a string from the UI
        var parsedDate = new Date(data.timestamp);
        if (!isNaN(parsedDate.getTime())) {
            data.timestamp = parsedDate.toISOString();
        } else {
            data.timestamp = new Date().toISOString(); // Fallback to current time
        }

        // Check if the guild has reached the limit of 10 submissions in the last 30 minutes
        var now = Date.now();
        var recentSubmissionsCount = 0;

        angular.forEach($scope.remoteItems, function(item) {
            if (item.guild === data.guild) {
                var lastSubTime = item.submittedAt || new Date(item.timestamp).getTime();
                if (now - lastSubTime < 1800000) { // 30 minutes in milliseconds
                    recentSubmissionsCount++;
                }
            }
        });

        if (recentSubmissionsCount >= 10) {
            alert('This guild has already submitted 10 kills in the last 30 minutes. Please wait before submitting more.');
            return;
        }

        // Record the exact time the submission was created to check against later
        data.submittedAt = now;

        $scope.remoteItems.$add(data).then(function () {
            alert('Submission added!');
            
            // Reset fields except guild and expansion
            var savedGuild = $scope.value.guild;
            var savedExpansion = $scope.value.expansion;
            
            var defaultTime = new Date();
            defaultTime.setSeconds(0, 0);
            
            $scope.value = {
                guild: savedGuild,
                expansion: savedExpansion,
                zone: '',
                boss: '',
                timestamp: defaultTime,
                imageUrl: ''
            };
            
            // Clear file input
            var fileupload = document.getElementById("fileupload");
            if (fileupload) {
                fileupload.value = '';
            }
        }).catch(function (error) {
            console.error("Submission Error:", error);
            alert('Error saving submission: ' + error.message);
        });
    }
}]);